<template>
  <div class="mytable">

    <div class=" head_info_rotate" v-if="closed && posMin">P</div>
    <div class=" head_info_rotate" v-if="closed && !posMin">Positions</div>

    <div v-show="positions_info" class="table">
      <div class="col" style="width: 25px; margin: 0; padding: 0;text-align: center">
        <div class="rotate" :class="{close:closed}" @click="hidden"><span> </span></div>
      </div>
      <div class="col" v-if="!closed">
        <div class="head_closed"> Positions
          <div class="account_info_small_top">{{ positions_info.length }}</div>
        </div>
      </div>
      <div class="col t_left" v-if="closed">
        <div class="head">Ticker</div>
        <template v-for="(item,i) in positions_info" :key="i">
          <div class="mytable_row" v-if="item.Shares!=0">{{ item.Ticker }}</div>
        </template>
      </div>
      <div class="col" v-if="closed">
        <div class="head">Shares</div>
        <template v-for="(item,i) in positions_info" :key="i">
          <div class="mytable_row" v-if="item.Shares!=0">{{ item.Shares }}</div>
        </template>
      </div>
      <div class="col" v-if="closed">
        <div class="head">Open price</div>
        <template v-for="(item,i) in positions_info" :key="i">
          <div class="mytable_row" v-if="item.Shares!=0">{{ item.OpenPrice }}</div>
        </template>
      </div>
      <div class="col" v-if="closed">
        <div class="head">Bid</div>
        <template v-for="(item,i) in positions_info" :key="i">
          <div class="mytable_row" v-if="item.Shares!=0">
            {{ getValue(instruments[item.Ticker], 'Bid') }}
          </div>
        </template>
      </div>
      <div class="col" v-if="closed">
        <div class="head">Last</div>
        <template v-for="(item,i) in positions_info" :key="i">
          <div class="mytable_row" v-if="item.Shares!=0">
            {{ getValue(instruments[item.Ticker], 'Last') }}
          </div>
        </template>
      </div>
      <div class="col" v-if="closed">
        <div class="head">Ask</div>
        <template v-for="(item,i) in positions_info" :key="i">
          <div class="mytable_row" v-if="item.Shares!=0">
            {{ getValue(instruments[item.Ticker], 'Ask') }}
          </div>
        </template>
      </div>
      <div class="col" v-if="closed">
        <div class="head">Open date</div>
        <template v-for="(item,i) in positions_info" :key="i">
          <div class="mytable_row" v-if="item.Shares!=0">{{ getStringTime(item.OpenDate) }}</div>
        </template>
      </div>

    </div>
  </div>
</template>

<script>
import {ref, watch} from "vue"
import {getInstruments} from "@/store/global";


export default {
  name: "PositionsTable",
  props: ["positions"],
  setup(props) {
    const pos = ref(props.positions);
    const res = pos.value.filter(item => item.Ticker.length > 4);
    const positions_info = ref(res);

    const instruments = getInstruments()
    const getValue = (obj, param) => {
      if (typeof (obj) != "undefined" && typeof (obj[param]) != "undefined") {
        return obj[param]
      }
      return 0
    }
    const posMin = ref(true)

    if (positions_info.value.length > 2) {
      posMin.value = false;
    }
    watch(() => props.positions, () => {
      //console.log(v)
      positions_info.value = props.positions.filter(item => item.Ticker.length > 4)
      if (positions_info.value.length > 2) {
        posMin.value = false
      } else {
        posMin.value = true
      }
      if (positions_info.value.length === 0) {
        closed.value = true
      }
    }, {deep: true})
    /*   watch(positions_info, (nV) => {
         if (nV.value.length > 2) {
           posMin.value = false
         } else {
           posMin.value = true
         }

       })*/
    const getStringTime = (val) => {
      // console.log("++++++++++"+val+"----------")
      if (val < 2613553314) {
        let ts = new Date(val * 1000);
        return (
            pad(ts.getDate()) +
            "/" +
            pad(ts.getMonth() + 1) +
            "/" +
            ts.getFullYear() +
            " " +
            pad(ts.getHours()) +
            ":" +
            pad(ts.getMinutes())
        );
      }
      return ""
    }
    const pad = (n) => {
      return n < 10 ? "0" + n : n;
    }
    const isset = (obj, param) => {
      if (typeof (obj) != "undefined" && obj.length > 0 && typeof (obj[param]) != "undefined" && obj[param].length > 0) {
        return true
      }
      return false
    }
    const hidden = () => {
      if (closed.value === false) {
        if (positions_info.value.length !== 0) {
          closed.value = true
        }
        return
      } else {
        closed.value = false
      }
    }
    const closed = ref(false)
    if (positions_info.value.length > 0) {
      closed.value = true
    }
    return {
      positions_info,
      getValue,
      getStringTime,
      isset,
      instruments,
      closed,
      hidden,
      posMin,
      pos
    }
  }
}
</script>

<style scoped>
div.rotate.close {
  background-color: white;
  border: none;
  color: white;
  display: inline-block;
  position: relative;
  margin: 0;
  padding: 0;
  width: 14px;
  height: 14px;
  cursor: pointer;
  transition: background 0s 0.3s;
  transform: rotate(45deg);
}

div.rotate {
  background-color: white;
  border: none;
  color: white;
  display: inline-block;
  position: relative;
  margin: 0;
  padding: 0;
  width: 14px;
  height: 14px;
  cursor: pointer;
  transition: background 0s 0.3s;
}

div.rotate:focus {
  outline: none;
  border: none;
  background-color: white;
}

div.rotate span {
  position: absolute;
  display: block;
  left: 0px;
  bottom: 6px;
  width: 100%;
  height: 2px;
  background-color: #000000;
  content: "";
}

div.rotate span::before {
  position: absolute;
  display: block;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #000000;
  content: "";
  transform: rotate(90deg);
}

.t_left {
  text-align: left !important;
}

.col {

  text-align: center;
}

.table {
  margin-top: 4px;
  width: 100%;
  display: table;
  table-layout: fixed;
  /*min-height: 80px;*/
}

.cel, .col {
  display: table-cell;
}

.vmiddle {
  vertical-align: middle;
}

.head {
  border-bottom: 1px solid #e82862;
  font-family: Proxima Nova Condensed;
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  line-height: 17px;
  color: #777777;
  width: 100%;
  padding-bottom: 4px;
  height: 17px;
}

.mytable {
  width: 100%;
  position: relative;
}

.head_info_rotate {

  position: absolute;
  left: -17px;
  top: 42px;
  padding: 0px;
  margin: 0px;
  -webkit-transform: rotate(-90deg);
  transform: rotate(-90deg);
  font-family: Proxima Nova Condensed;
  font-size: 9px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: #222222;
  width: 60px;
  text-align: right;
}

.head_closed {
  font-family: Proxima Nova Condensed;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: #222222;
  border-bottom: 1px solid #e82862;
  padding-bottom: 1px;
}

.account_info_small_top {
  margin-left: 3px;
  font-family: Proxima Nova Condensed;
  font-size: 10px;
  font-style: normal;
  font-weight: normal;
  line-height: 12px;
  color: #777777;
  position: absolute;
  display: inline-block;
}

.mytable_row {
  height: 20px;
}

.col .mytable_row:nth-child(even) {
  background-color: #f7f7f7;
}
</style>
